//export const specialCharacterRegex = /^[^*|\:<>[\]{}`\\()#^!%~;@&$]+$/;
export const specialCharacterRegex = /^./;

export const specialCharacterCheck = val => {
  return specialCharacterRegex.test(val);
};

export const decimalCheck = (val, count) => {
  // Only allow "number & ." input
  const cleanNumber = val.replace(/[^0-9.]/g, "");

  // Only take first 2 values from split. Ignore the rest.
  const strAfterDot = cleanNumber.split(".", 2)[1];
  if (strAfterDot) {
    if (strAfterDot.length <= 2) {
      return val;
    } else {
      const strBeforeDot = cleanNumber.split(".", 1)[0];
      return strBeforeDot + "." + strAfterDot.substr(0, count);
    }
  } else {
    return val;
  }
};
